<template>
    <ui5-table class="translations-display">
        <ui5-table-row
            v-for="(text, language) in translationData"
            :key="language">
            <ui5-table-cell class="language">
                {{ getEmoji(language) }} {{ language }}
            </ui5-table-cell>
            <ui5-table-cell class="text">{{ text }}</ui5-table-cell>
        </ui5-table-row>
    </ui5-table>
</template>

<script>
import LocalizationHelper from '../helpers/LocalizationHelper';
export default {
    props: {
        translationData: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getEmoji: LocalizationHelper.languageCodeToEmoji,
    },
    computed: {},
};
</script>
